<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <!-- <a class="col-md-4" routerLink="../roles">
      << Back to manage roles</a> -->
      <div class="page-header">
        <div class="row row-with-negative-margin mb-3">
          <div class="col-6">
            <h2>List of roles</h2>
            <p class="mb-0">Edit & Delete role and customize permissions.</p>
            <button class="back-button pr-3 pl-0 back-btn-white-bg ng-star-inserted" routerLink="../roles"><i
                aria-hidden="true" class="fa fa-chevron-circle-left"></i>Back</button>
          </div>
          <div class="col-6 d-flex align-items-end justify-content-end">
            <button pButton class="blue-nav-btn-above-lists float-right" type="button" title="Manage Applications"
              [disabled]="!selectedRows || (selectedRows.length === 0)" label="Map Application"
              (click)="showDialog()"></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row col-md-12">
    <p-table class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
      styleClass="p-datatable-striped" [value]="roleModuleList" *ngIf="roleModuleList?.length > 0" dataKey="id"
      [(selection)]="selectedRows">
      <ng-template pTemplate="header">
        <tr class="text-uppercase">
          <th scope="col" style="width: 50px;">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th scope="col">Role</th>
          <th scope="col">Description</th>
          <th scope="col">Modules</th>
          <th scope="col">Application</th>
          <th scope="col">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr>
          <td>
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
          <td>{{row.name}}</td>
          <td>{{row.description}}</td>
          <td>
            <div *ngFor="let item of row?.modulePermissions">
              <span *ngIf="row['modulePermissions'].length > 0">{{item['moduleName']}}</span>
              <span *ngIf="row['modulePermissions'].length <= 0">
                <p> Hi</p>
              </span>
            </div>
          </td>
          <td>{{row.applicationName}}</td>
          <td>
            <div class="subtask-form-header-buttons-holder">
              <mat-icon matTooltip="Edit" class="mr-2" (click)="handleEdit(row);">edit</mat-icon>
              <mat-icon matTooltip="Delete" class="border-left pl-2" (click)="deletePrompt(row.id);">
                delete_forever
              </mat-icon>
            </div>
          </td>
        </tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="3" style="text-align:center;">No data</td>
        </tr>
      </ng-template>
    </p-table>
    <div *ngIf="roleModuleList?.length == 0" class="mt-4 text-center">No Data</div>
    <p-paginator class="paginator" [rows]="pageSize" (onPageChange)="paginationEvent($event)"
      *ngIf="roleModuleList?.length > 0" [rowsPerPageOptions]="pageSizeOptions">
    </p-paginator>
  </div>
</div>

<p-dialog header="Map Application" [(visible)]="displayPopup" [modal]="true" [style]="{width: '50vw'}">
  <div class="container-fluid">
    <form [formGroup]="form" class="common-form-styles" (ngSubmit)="onSubmit()">
      <div class="row row-with-negative-margin">
        <div class="form-group col-6">
          <label for="application">Application</label>
          <p-dropdown [options]="applications" optionLabel="name" optionValue="id" formControlName="application"
            placeholder="Select" class="p-form-control" appendTo="body" [showClear]="true"></p-dropdown>
          <small *ngIf="form.get('application').touched && form.get('application').errors?.required"
            class="p-error">Selecting an application is mandatory.</small>
        </div>
      </div>
      <button type="submit" pButton label="Map"></button>
    </form>
  </div>
</p-dialog>
